/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_mobile_analytics_app_id": "10e03627a0fd4f6bbe8e8780b231f551",
    "aws_mobile_analytics_app_region": "eu-west-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "10e03627a0fd4f6bbe8e8780b231f551",
            "region": "eu-west-1"
        }
    },
    "aws_cognito_identity_pool_id": "eu-west-1:81dfcf67-6670-4520-b4db-ce56f382acb5",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_Son5U1nZE",
    "aws_user_pools_web_client_id": "3ja9vigmvf7833fhosgt3a8ms5",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "infusion-whatsapp-webdev-storage-09ce1a0a112534-newwebprod",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
